export class EcartProtocole {
    Ecart: boolean;
    Justification: string;

    static mapFromJSON(json): EcartProtocole {
        const e = new EcartProtocole();

        e.Ecart = json.ecart;
        e.Justification = json.justification;
        
        return e;
    }
}
